import React from 'react';
import BarsContainer from '../bars';
import HomeDoble from '../doubleHome';
import Home from '../home';
import {
  getModuleAmp,
  getModuleWeb,
  MODULE_TYPES,
  LA_SEXTA,
  ANTENA3,
  ONDACERO,
} from '../moduleGenerator/utils';
import Pactometro from '../pactometro';
import { Card, TYPES } from '@atresmedia/elections_modules_library';
import SumaBloques from '../sumaBloques';
import { getParams } from '../../utils';
import RankingPactometro from '../rankingPactometro';

const getAMPHeight = (type, electionType, location) => {
  switch (type) {
    case MODULE_TYPES.RESULTADOS:
      return 620; //resultados;
    case MODULE_TYPES.RESULTADOS_DOBLES:
      return 1220; //resultadosDobles;
    case MODULE_TYPES.PACTOMETRO:
      return 320; //pactometro;
    case MODULE_TYPES.BARRAS:
      return 360; //bars;
    case MODULE_TYPES.RANKING:
      return 550; //rankingPactometro;
    case MODULE_TYPES.MINI:
      return 230; //sumaBloques;
    default:
      throw new Error('Error');
  }
};

const getHtmlName = (type, electionType, location) => {
  switch (type) {
    case MODULE_TYPES.RESULTADOS:
    case MODULE_TYPES.RESULTADOS_DOBLES:
      switch (electionType) {
        case TYPES.GENERAL:
          return location && location.typePlace === 'TOWN'
            ? 'detalle'
            : 'resultados';
        case TYPES.REGIONAL:
          return location.typePlace === 'TOWN'
            ? 'detalleAutonomica'
            : 'resultados';
        case TYPES.MUNICIPAL:
          return location.typePlace === 'TOWN'
            ? 'detalleMunicipal'
            : 'resultados';
        case TYPES.EUROPEAN:
          return location.typePlace === 'TOWN'
            ? 'detalleEuropeas'
            : 'resultados';
        default:
          throw new Error('Error');
      }
    case MODULE_TYPES.PACTOMETRO:
      return 'pactometro';
    case MODULE_TYPES.ARCO:
      return 'graficas';
    case MODULE_TYPES.BARRAS:
      return 'bars';
    case MODULE_TYPES.RANKING:
      return 'rankingPactometro';
    case MODULE_TYPES.MINI:
      return 'sumaBloques';
    case MODULE_TYPES.ARCO_SENADO:
      return 'senate';
    default:
      throw new Error('Error');
  }
};

const getLocationPath = (type, locations) => {
  let location = locations[0];
  let firstParams = getParams(location);
  const {
    communities = firstParams.community,
    provinces = firstParams.province,
    towns = firstParams.town,
  } = getDoubleParams(firstParams, getParams(locations[1]));

  return `${communities}${provinces ? '/' + provinces : ''}${
    towns ? '/' + towns : ''
  }`;
};

const getChartType = (type, site) => {
  switch (type) {
    case MODULE_TYPES.RESULTADOS:
    case MODULE_TYPES.RESULTADOS_DOBLES:
      switch (site) {
        case LA_SEXTA:
          return 'bars';
        case ONDACERO:
        case ANTENA3:
          return 'arc';
        default:
          return '';
      }
    default:
      return '';
  }
};

const getUrlImg = (site) => {
  switch (site) {
    case LA_SEXTA:
      return 'https://www.lasexta.com/public/img/grupo-atresmedia.svg';
    case ONDACERO:
      return 'https://www.ondacero.es/public/img/grupo-atresmedia.svg';
    case ANTENA3:
      return 'https://www.antena3.com/public/img/grupo-atresmedia.svg';
    default:
      return '';
  }
};

const getUrl = (
  type,
  electionType,
  locations,
  navegable,
  chartTypes,
  community
) => {
  if (electionType !== TYPES.GENERAL) {
    return `/1/${navegable}/2020/REGIONAL/1/${
      chartTypes ? chartTypes + '/' : ''
    }${getLocationPath(electionType, locations)}/${getHtmlName(
      type,
      electionType,
      locations
    )}.html`;
  } else if (locations.length > 0) {
    return `/C108/${navegable}/2020/GENERAL/1/${
      chartTypes ? chartTypes + '/' : ''
    }${getLocationPath(electionType, locations)}/${getHtmlName(
      type,
      electionType,
      locations
    )}.html`;
  } else {
    return `/C108/${navegable}/2020/GENERAL/1/${
      chartTypes ? chartTypes + '/' : ''
    }${getHtmlName(type, electionType, locations)}.html`;
  }
};

const getDoubleParams = (
  { community = '', province = '', town = '' },
  second
) => {
  let result = {
    communities:
      (community || second.community) &&
      community + (second.community ? '-' : '') + (second.community || ''),
    provinces:
      (province || second.province) &&
      province + (second.province ? '-' : '') + (second.province || ''),
    towns:
      (town || second.town) &&
      town + (second.town ? '-' : '') + (second.town || ''),
  };
  return result;
};

const Module = (data) => {
  const { type, electionType, locations = [], navegable, site } = data;
  const location = locations[0];
  const moduleId = 'elections_module_' + new Date().getTime();

  const { community, province = '', town = '' } = getParams(location);
  const chartType = getChartType(type, site);
  const url = getUrl(
    type,
    electionType,
    locations,
    navegable,
    chartType,
    community,
    site
  );
  const urlImg = getUrlImg(site);
  const moduleWeb = getModuleWeb(moduleId, url);
  const moduleHeight = getAMPHeight(type, electionType, locations);
  const moduleAmp = getModuleAmp(url, moduleHeight, urlImg);

  const typeElec = TYPES.REGIONAL;

  const match = {
    params: {
      year: '2020',
      type: typeElec,
      electionType: typeElec,
      electionNumber: '1',
      placeId: typeElec === TYPES.REGIONAL ? community : 'C108',
      province,
      community,
      town,
      site: site,
      //Para doble home
      provinces: province,
      communities: community,
      towns: town,
      chartType,
      chartTypes: chartType,
      placesIds: typeElec === TYPES.REGIONAL ? community : 'C108',
    },
  };

  if (locations.length > 1) {
    match.params = {
      ...match.params,
      ...getDoubleParams(
        { community, province, town },
        getParams(locations[1])
      ),
    };
  }

  return (
    <div>
      <Card title="Vista previa" className="vistaprevia" isCollapsed="true">
        {type === MODULE_TYPES.BARRAS && <BarsContainer match={match} />}
        {type === MODULE_TYPES.RESULTADOS && <Home match={match} />}
        {type === MODULE_TYPES.RESULTADOS_DOBLES && <HomeDoble match={match} />}
        {type === MODULE_TYPES.PACTOMETRO && <Pactometro match={match} />}
        {type === MODULE_TYPES.MINI && <SumaBloques match={match} />}
        {type === MODULE_TYPES.RANKING && <RankingPactometro match={match} />}
      </Card>

      <Card title="Módulos" className="vistaprevia">
        <div className="two">
          <h3>Módulo web</h3>
          <textarea readOnly value={moduleWeb} />
        </div>
        <div className="two">
          <h3>Módulo AMP</h3>
          <textarea readOnly value={moduleAmp} />
        </div>
      </Card>
    </div>
  );
};

export default Module;
